import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";
import {getHintData} from "../../../../../store/reducers/hint";
import {IHint} from "../../../../../data/data";
import HighlightText from "../../../../common/highlight-text/HighlightText";
import CloseButton from '../CloseButton';

interface HintProps
{
    onClose?: () => void;
    hint: IHint;
}

import './Hint.scss';


class Hint extends React.Component<HintProps, null>
{
    constructor(public props: HintProps)
    {
        super(props);
    }


    getHints = () =>
    {
        const {hint} = this.props;
        const {hints} = hint;

        return _.map(hints, (hint: string, i: number)=>
        {
            return <li
                        styleName={'hint-list-item'}
                        key={i}>

                <i className="fas fa-lightbulb" />

                <span dangerouslySetInnerHTML={{ __html: hint }}/>

            </li>
        })
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {hint} = this.props;

        if (! hint) return null;

        return <div styleName={'hint-content'}>

            <CloseButton onClose={this.props.onClose}/>

            <div styleName={'text-column'}>

                <HighlightText type={'blue'}>hint</HighlightText>

                {/*<h4 styleName={'headline'}>{title}</h4>*/}

                {/*<p styleName={'body-copy'}>{description}</p>*/}

                <ul styleName={'hint-list'}>

                    {this.getHints()}

                </ul>

            </div>

        </div>;
    }
}


const mapStateToProps = state =>
{
    return {
        hint: getHintData(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Hint);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/hint/Hint.tsx